/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserExcludingFcmMessageIdFcmTokenWithRelations } from './userExcludingFcmMessageIdFcmTokenWithRelations';
import { RequisitionStatusExcludingFcmMessageIdFcmTokenWithRelations } from './requisitionStatusExcludingFcmMessageIdFcmTokenWithRelations';


/**
 * (tsType: Omit<RequisitionStatusHistoryWithRelations, \'fcmMessageId\' | \'fcmToken\'>, schemaOptions: { includeRelations: true, exclude: [ \'fcmMessageId\', \'fcmToken\' ] })
 */
export interface RequisitionStatusHistoryExcludingFcmMessageIdFcmTokenWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    requisitionId: string;
    comments?: string;
    statusId?: string;
    previousStatusId?: string;
    changedBy?: number;
    status?: RequisitionStatusExcludingFcmMessageIdFcmTokenWithRelations;
    previousStatus?: RequisitionStatusExcludingFcmMessageIdFcmTokenWithRelations;
    changedUser?: UserExcludingFcmMessageIdFcmTokenWithRelations;
}

